import { __extends, __assign } from 'tslib';
import React__default from 'react';
import Checkbox from '../Checkbox/Checkbox.component.js';
import Divider from '../Divider/Divider.component.js';
import { propTypes, defaultProps } from './SelectionList.types.js';
import styles from './SelectionList.module.scss.js';

var SelectionList = /** @class */ (function (_super) {
    __extends(SelectionList, _super);
    function SelectionList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * When specific item selection change, send updates selection array
         * @param value: checked/unchecked item reference
         * @param selected: expected state
         */
        _this.updateItemSelection = function (value, selected) {
            var _a = _this.props, selection = _a.selection, onSelectionChange = _a.onSelectionChange;
            var updatedSelection = selection.map(function (item) {
                if (item.value === value) {
                    return __assign(__assign({}, item), { selected: selected });
                }
                return item;
            });
            onSelectionChange(updatedSelection);
        };
        /**
         * Clicking select all should apply expected selection to all selection items.
         * @param selectAll: expected select all state.
         */
        _this.updateSelectAll = function (selectAll) {
            var _a = _this.props, selection = _a.selection, onSelectionChange = _a.onSelectionChange;
            onSelectionChange(selection.map(function (item) { return (__assign(__assign({}, item), { selected: selectAll })); }));
        };
        /** Computed selectAll status */
        _this.selectAllSelected = function () {
            var selection = _this.props.selection;
            return !selection.some(function (item) { return !item.selected; });
        };
        /** Render "Select All" control if enabled, - if any item is selected. */
        _this.renderSelectAll = function () {
            var _a = _this.props, selection = _a.selection, enableSelectAll = _a.enableSelectAll, labelClassName = _a.labelClassName, withDividers = _a.withDividers, testId = _a.testId, labelForSelectAll = _a.labelForSelectAll;
            if (!enableSelectAll)
                return React__default.createElement(React__default.Fragment, null);
            // If some items are unselected there should be different icon
            var hasSelectedItem = selection.some(function (item) { return !!item.selected; });
            var allSelected = _this.selectAllSelected();
            return (React__default.createElement("li", { className: styles.SelectionList_selectionItem, key: "selectAll" },
                React__default.createElement("div", { className: styles.SelectionItem },
                    React__default.createElement(Checkbox, { indeterminate: !allSelected && hasSelectedItem, checked: hasSelectedItem, onChange: function () {
                            return _this.updateSelectAll(!allSelected);
                        }, "data-testid": (_this.props['data-testid'] || testId) + "SelectAllCheckbox" }),
                    React__default.createElement("div", { className: styles.SelectionItem_label + " " + (labelClassName || ''), onClick: function () { return _this.updateSelectAll(!allSelected); }, "data-testid": (_this.props['data-testid'] || testId) + "SelectAllLabel" }, labelForSelectAll)),
                withDividers && (React__default.createElement(Divider, { className: styles.SelectionItem_divider }))));
        };
        /**
         * Helper for rendering each selection list item.
         * @param item: selection array member
         */
        _this.renderSelectionItem = function (item) {
            var _a = _this.props, withDividers = _a.withDividers, testId = _a.testId;
            return (React__default.createElement("li", { className: styles.SelectionList_selectionItem, key: item.value },
                React__default.createElement("div", { className: styles.SelectionItem },
                    React__default.createElement(Checkbox, { checked: !!item.selected, onChange: function () {
                            _this.updateItemSelection(item.value, !item.selected);
                        }, "data-testid": (_this.props['data-testid'] || testId) + "SelectCheckbox" + item.value }),
                    React__default.createElement("div", { className: styles.SelectionItem_label + " " + (_this.props.labelClassName || ''), onClick: function () {
                            return _this.updateItemSelection(item.value, !item.selected);
                        }, "data-testid": (_this.props['data-testid'] || testId) + "SelectLabel" + item.value }, item.label || item.value)),
                withDividers && (React__default.createElement(Divider, { className: styles.SelectionItem_divider }))));
        };
        return _this;
    }
    SelectionList.prototype.componentDidMount = function () {
        if (this.props.testId) {
            console.warn('DEPRECATION WARNING: The `testId` prop is deprecated and support for it will be removed soon. Please use `data-testid` instead.');
        }
    };
    SelectionList.prototype.render = function () {
        var _a = this.props, selection = _a.selection, className = _a.className;
        return (React__default.createElement("ul", { className: "\n                    " + styles.SelectionList + "\n                    " + className + "\n                " },
            this.renderSelectAll(),
            selection.map(this.renderSelectionItem)));
    };
    SelectionList.displayName = 'SelectionList';
    SelectionList.propTypes = propTypes;
    SelectionList.defaultProps = __assign({}, defaultProps);
    return SelectionList;
}(React__default.Component));

export { SelectionList as default };
